<script setup lang="ts">
import { defineProps, onMounted, ref } from 'vue'
import { printPhone } from '@/utils/phones'
import ButtonCallTo from '@/components/common/buttons/ButtonCallTo.vue'
import ButtonMailTo from '@/components/common/buttons/ButtonMailTo.vue'
import { DevicePhoneMobileIcon, LinkSlashIcon } from '@heroicons/vue/24/outline'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
import IconWithTooltip from '@/components/common/ui/IconWithTooltip.vue'
const props = defineProps(['params'])
const partnerId = ref()
const phone = ref()
const mobile = ref()
const email = ref()

onMounted(() => {
  partnerId.value = props.params.data.id
  phone.value = props.params.data.phone
  mobile.value = props.params.data.mobile
  email.value = props.params.data.email
})
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <div class="w-10">
      <ButtonCallTo
        :disabled="!phone"
        :partner-id="partnerId"
        :contact-id="params.data.id"
        :phone="printPhone(phone)"
        :tooltip-position="params.tooltipPosition"
      />
    </div>
    <div class="w-10">
      <ButtonCallTo
        :disabled="!mobile"
        :partner-id="partnerId"
        :contact-id="params.data.id"
        :phone="printPhone(mobile)"
        :icon="DevicePhoneMobileIcon"
        :tooltip-position="params.tooltipPosition"
      />
    </div>
    <div class="w-10">
      <ButtonMailTo :disabled="!email" :email="email" :tooltip-position="params.tooltipPosition" />
    </div>

    <div class="w-10">
      <icon-with-tooltip
        class="w-10"
        :text="'Retirer'"
        @click="params.onClick(params.data)"
        :icon="LinkSlashIcon"
      />
    </div>

    <router-link
      class="w-fit"
      v-if="partnerId"
      :to="{ name: 'partner', params: { partnerId: partnerId } }"
    >
      <ButtonDaisy text="Détail" class="mb-2" />
    </router-link>
  </div>
</template>
